/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { keyframes, styled } from '@mui/system';
export const StyledCarousel = styled('div') `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 1px;
  overflow: hidden;
`;
const infiniteLoadingAnimation = keyframes `
  0% { transform: translateX(0); }
  100% { transform: translateX(-288px)}
`;
export const StyledSlides = styled('div') `
  display: flex;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  width: 100%;
  & > * {
    scroll-snap-align: center;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  animation-name: ${infiniteLoadingAnimation};
  animation-iteration-count: infinite;
  animation: scroll linear infinite;
  transition: transform 0.5s ease-in-out;
  -webkit-overflow-scrolling: touch;
`;
export const StyledSlide = styled('div') `
  overflow: hidden;
  background: #f7f7f7;
  border-radius: 8px;
  width: calc(1086px / 4);
  height: calc(1086px / 4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  scroll-snap-align: start;
`;
export const StyledDots = styled('div') `
  display: flex;
`;
export const StyledDot = styled('span') `
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: #888;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  ${({ isActive }) => isActive &&
    `
    background-color: #333;
  `}
`;
